<template>
  <div class='section-header__container'>
    <img class='section-header__image' src='@/assets/images/main/section-header.svg'>
    <img class='section-header__image--mobile' src='@/assets/images/main/section-header-mobile.svg'>
    <span>{{title}}</span>
  </div>
</template>
<script>
export default {
  name: 'SectionHeader',
  props: {
    title: String
  }
}
</script>
<style lang="scss">
@import '../sass/_variables.scss';
.section-header__container {
  position: relative;
  height: 6vw;

  span {
    position: absolute;
    color: $fc-chrome;
    font-size: 2vw;
    top: 1.5vw;
    text-transform: capitalize;
    padding-left: 30px;

    @media (min-width: $lg-screen) {
      font-size: 1.5vw;
    }

    @media (max-width: $md-screen) {
      font-size: 16px;
      bottom: 5px;
      top: auto;
      padding-left: 3vw;
    }

    @media (max-width: $sm-screen) {
      font-size: 14px;
      top: 1.5vw;
    }
  }

  @media (max-width: $md-screen) {
    height: 7vw;
    margin-right: 5px;
  }
}
.section-header__image {
  position: absolute;
  
  @media (max-width: $md-screen) {
    display: none;
  }
}
.section-header__image--mobile {
  position: absolute;
  display: none;
  height: 8vw;
  width: 100%;

  @media (max-width: $md-screen) {
    display: block;
  }
}
</style>